module.exports = __webpack_public_path__ + "static/img/biodiversidad.14dad689.png";